export default {
  supervisor: [
    {
      title: true,
      name: 'Supervisor',
    },
    {
      name: 'Home',
      url: '/',
      icon: 'icon-home',
    },
    {
      name: 'Dashboard',
      url: '/dashboard',
      icon: 'icon-grid',
    },
    {
      name: 'Interactions',
      url: '/interactions',
      icon: 'icon-bubbles',
      badge: {
      },
    },
    {
      name: 'Video Call',
      url: '/videoCall',
      icon: 'icon-bubbles',
    },
    {
      name: 'Customers',
      url: '/customers',
      icon: 'icon-people',
    },
    {
      name: 'CRM',
      url: '/crm/chatbot',
      icon: 'icon-earphones-alt',
    },
    {
      name: 'Broadcast',
      url: '/broadcast',
      icon: 'icon-speech',
    },
    {
      name: 'Chat Flow (Beta)',
      url: '/chatflow',
      icon: 'icon-shuffle',
    },
    {
      divider: true,
    }, /* ,
    {
      title: true,
      name: 'Agents'
    },
    {
      name: 'Interactions',
      url: '/interactions',
      icon: 'icon-bubbles'
    },
    {
      name: 'Customers',
      url: '/customers',
      icon: 'icon-people'
    } */
  ],
  agent: [
    {
      name: 'Dashboard',
      url: '/dashboard',
      icon: 'icon-home',
    },
    {
      divider: true,
    },
    {
      title: true,
      name: 'Agent',
    },
    {
      name: 'Interactions',
      url: '/interactions/supervisor',
      icon: 'icon-bubbles',
      badge: {
      },
    },
    {
      name: 'Video Call',
      url: '/videoCall',
      icon: 'icon-bubbles',
    },
    {
      name: 'Customers',
      url: '/customers',
      icon: 'icon-people',
    },
    {
      name: 'CRM',
      icon: 'icon-earphones-alt',
      children: [
        {
          name: 'Workshop Appt.',
          url: '/crm/appointment',
          icon: 'icon-calendar',
        },
        {
          name: 'Motor Insurance',
          url: '/crm/motor-insurance',
          icon: 'icon-wrench',
        },
      ],
    },
    {
      name: 'Broadcast',
      url: '/broadcast',
      icon: 'icon-speech',
    },
    {
      name: 'Chat Flow (Beta)',
      url: '/chatflow',
      icon: 'icon-shuffle',
    },
    {
      divider: true,
    }, /* ,
    {
      title: true,
      name: 'Agents'
    },
    {
      name: 'Interactions',
      url: '/interactions',
      icon: 'icon-bubbles'
    },
    {
      name: 'Customers',
      url: '/customers',
      icon: 'icon-people'
    } */
  ],
  admin: [
    {
      title: true,
      name: 'Admin',
    },
    {
      name: 'Home',
      url: '/',
      icon: 'icon-home',
    },
    {
      name: 'Dashboard',
      url: '/dashboard',
      icon: 'icon-grid',
    },
    {
      name: 'Interactions',
      url: '/interactionsMenu',
      icon: 'icon-bubbles',
      badge: {
        variant: 'danger',
        text: '',
      },
      id: 'interaction',
      children: [
        {
          name: 'Live',
          url: '/interactions/live',
          icon: 'fa fa-commenting',
          badge: {
            variant: 'danger',
            text: '',
          },
        },
        {
          name: 'Historical',
          url: '/interactions/historical',
          icon: 'icon-book-open',
        },
      ],
    },
    // {
    //   name: 'Interactions',
    //   url: '/interactions/',
    //   icon: 'icon-bubbles',
    // },
    {
      name: 'Video Call',
      url: '/videoCall',
      icon: 'icon-bubbles',
    },
    {
      name: 'Customers',
      url: '/customers',
      icon: 'icon-people',
    },
    {
      name: 'CRM',
      icon: 'icon-earphones-alt',
      children: [
        {
          name: 'Account Opening',
          url: '/crm/accountOpening',
          icon: 'fa fa-id-card-o',
        },
        {
          name: 'Task Reporting',
          url: '/crm/chatbot',
          icon: 'fa fa-id-card-o',
        },
        {
          name: 'Motor Accident',
          url: '/crm/appointment',
          icon: 'fa fa-car',
        },
        {
          name: 'Job Listing',
          url: '/crm/JobListing',
          icon: 'fa fa-bar-chart',
        },
      ],
    },
    {
      name: 'Broadcast',
      url: '/broadcast',
      icon: 'icon-speech',
    },
    {
      name: 'Analytics',
      icon: 'icon-graph',
      children: [
        {
          name: 'Visitor Timeline',
          url: '/Analytics/VisitorTimeline',
          icon: 'fa fa-line-chart',
        },
        {
          name: 'Daily Visitor',
          url: '/Analytics/DailyVisitor',
          icon: 'fa fa-table',
        },
        {
          name: 'Interactions Timeline',
          url: '/Analytics/InteractionsTimeline',
          icon: 'fa fa-line-chart',
        },
        {
          name: 'Daily Interactions',
          url: '/Analytics/DailyInteractions',
          icon: 'fa fa-table',
        },
        {
          name: 'Intents Pie',
          url: '/Analytics/IntentsPie',
          icon: 'fa fa-pie-chart',
        },
        {
          name: 'Intents Treemap',
          url: '/Analytics/IntentsTreemap',
          icon: 'fa fa-pie-chart',
        },
        {
          name: 'Intents List',
          url: '/Analytics/IntentsList',
          icon: 'fa fa-table',
        },
      ],
    },
    {
      name: 'NL Studio',
      icon: 'fa fa-magic',
      url: '/studio',
      // children: [
      //   {
      //     name: 'Intents List',
      //     url: '/Dialog/IntentsList',
      //     icon: 'fa fa-book'
      //   },
      //   {
      //     name: 'Intents Manager',
      //     url: '/Dialog/IntentsManager',
      //     icon: 'fa fa-bookmark'
      //   }
      // ]
    },
    {
      name: 'Unmatched Query',
      url: '/fallback/',
      icon: 'fa fa-table',
    },
    {
      divider: true,
    }, /* ,
    {
      title: true,
      name: 'Agents'
    },
    {
      name: 'Interactions',
      url: '/interactions',
      icon: 'icon-bubbles'
    },
    {
      name: 'Customers',
      url: '/customers',
      icon: 'icon-people'
    } */
  ],
  items: [
    {
      name: 'Dashboard',
      url: '/dashboard',
      icon: 'icon-home',
    },
    {
      divider: true,
    },
    {
      title: true,
      name: 'Supervisor',
    },
    {
      name: 'Interactions',
      url: '/interactions/supervisor',
      icon: 'icon-bubbles',
      badge: {
      },
    },
    {
      name: 'Customers',
      url: '/customers',
      icon: 'icon-people',
    },
    {
      name: 'CRM',
      icon: 'icon-earphones-alt',
      children: [
        {
          name: 'Workshop Appt.',
          url: '/crm/appointment',
          icon: 'icon-calendar',
        },
        {
          name: 'Motor Insurance',
          url: '/crm/motor-insurance',
          icon: 'icon-wrench',
        },
      ],
    },
    {
      name: 'Broadcast',
      url: '/broadcast',
      icon: 'icon-speech',
    },
    {
      name: 'Chat Flow (Beta)',
      url: '/chatflow',
      icon: 'icon-shuffle',
    },
    {
      divider: true,
    }, /* ,
    {
      title: true,
      name: 'Agents'
    },
    {
      name: 'Interactions',
      url: '/interactions',
      icon: 'icon-bubbles'
    },
    {
      name: 'Customers',
      url: '/customers',
      icon: 'icon-people'
    } */
  ],
}



// WEBPACK FOOTER //
// ./src/_nav.js